import { gql } from '@apollo/client';
import { API_FIELDS_APPLICATION as APPLICATION, API_FIELDS_APPLICATION_LANGUAGE as LANGUAGE } from '@enroller/admissions-components';
import { createStringPayload, createNestedPayload } from '../utils/formatSchema';

import type { FieldResponse } from '../graphqlResponse';

export const STUDENT_SCHOOL_FIELDS = [
  APPLICATION.ID,
  APPLICATION.typeOfSchool,
  APPLICATION.typeOfSchoolOther,
  APPLICATION.gradeLevel,
  APPLICATION.highestGradLevelSchool,
  APPLICATION.graduationSituation,
  APPLICATION.graduationDate,
  APPLICATION.yearsOfEnglish,
  APPLICATION.nativeLanguage,
];

export const STUDENT_LANGUAGES_FIELDS = [LANGUAGE.language, LANGUAGE.id, LANGUAGE.numberOfYears];

export const SCHOOL_AND_LANGUAGES_GQL = `
  ${createStringPayload(STUDENT_SCHOOL_FIELDS)}
  ${createNestedPayload(APPLICATION.languageListGET, STUDENT_LANGUAGES_FIELDS)}
`;

export const SCHOOL_AND_LANGUAGES_QUERY = gql`
  query StudentApp($appId: String!) {
    Records {
      Students_Applications(where: { id: { equals: $appId } }) {
        _data {
          ${SCHOOL_AND_LANGUAGES_GQL}
        }
      }
    }
  }`;

type StudentSchoolResponse = FieldResponse<typeof STUDENT_SCHOOL_FIELDS>;
type LanguageResponse = FieldResponse<typeof STUDENT_LANGUAGES_FIELDS>;

export type SchoolsAndLanguagesResponse = StudentSchoolResponse & {
  [APPLICATION.languageListGET]: {
    _data: LanguageResponse[];
  };
};
